import styles from "./NoContent.module.css";
import Icon from "./Icon";

interface NoContentProps {
    msg: string;
    icon: string;
}

const NoContent = (props: NoContentProps) => {
    return (
        <div className={styles.content}>
            <Icon name={props.icon} size="xlarge" color="lightGrey" />
            <div>{props.msg}</div>
        </div>
    );
};

export default NoContent;
